import React from 'react';
import ReactDOM from 'react-dom/client';
import 'bootstrap/dist/css/bootstrap.css';
import App from './App';


const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
 
     <App />

  </React.StrictMode>
);


//alle mogelijke API's om te gebruiken in webapp
//https://github.com/public-apis/public-apis 

